import type { ReadConfig } from 'api-read-hook';
import type { HydraCollection } from '../../types';

import { useApiRead } from 'api-read-hook';
import { makeQueryString } from '../../util';

export type V_Detail = {
  '@id': string;
  '@type': 'ReflectionPoint';
  id: string;
  title: string;
  userAnswer: {
    '@id': string;
    '@type': 'UserSimpleAnswer';
    id: string;
    answer: string;
  } | null;
};

export type V_DetailAsAdmin = {
  '@id': string;
  '@type': 'ReflectionPoint';
  id: string;
  title: string;
  position: number;
  publishedAt: string | null;
};

export type V_ProgramWeekSub = {
  '@id': string;
  '@type': 'ReflectionPoint';
  id: string;
  title: string;
  position: number;
  publishedAt: string | null;
  updatedAt: string | null;
};

export type W = {
  title: string;
  position: number;
  week: string;
};

export function useReadCollectionProgramWeekAsAdminSub(
  id: string,
  queryParams?: { 'order[position]'?: string; title?: string },
  options?: ReadConfig,
) {
  return useApiRead<HydraCollection<V_ProgramWeekSub>>(
    `/program-weeks/${id}/reflection-points/as-admin${makeQueryString(
      queryParams,
    )}`,
    options,
  );
}

export function useReadCollectionProgramWeekSub(
  id: string,
  queryParams?: { 'order[position]'?: string; title?: string },
  options?: ReadConfig,
) {
  return useApiRead<HydraCollection<V_ProgramWeekSub>>(
    `/program-weeks/${id}/reflection-points${makeQueryString(queryParams)}`,
    options,
  );
}

export function useReadItem(id: string, options?: ReadConfig) {
  return useApiRead<V_Detail>(`/reflection-points/${id}`, options);
}

export function useReadItemAsAdmin(id: string, options?: ReadConfig) {
  return useApiRead<V_DetailAsAdmin>(
    `/reflection-points/${id}/as-admin`,
    options,
  );
}
